export const siteInfo = {
  brand: "朋友的妈妈3",
  brandFull: "朋友的妈妈3 影视专站",
  slogan: "最新剧情介绍与影视资讯",
  intro:
    "本站是《朋友的妈妈3》的专题影视内容站，专注于该作品的最新剧情介绍、影视资讯与剧集资料整理，为喜爱这部作品的观众提供一站式浏览体验。",
  contactEmail: "contact@friendmother3.example",
  year: "2026",
};

export const siteTdk = {
  home: {
    title: "朋友的妈妈3 - 最新剧情介绍与影视资讯",
    description:
      "朋友的妈妈3官网，提供最新剧情介绍、影视资讯和相关影片信息，全方位满足粉丝对作品的了解与追踪需求。",
    keywords: "朋友的妈妈3,朋友的妈妈3剧情,朋友的妈妈3影视,朋友的妈妈3介绍,朋友的妈妈3资讯",
  },
};

export type HeroSlide = {
  id: string;
  image: string;
  tag: string;
  title: string;
  subtitle: string;
  desc: string;
  link: string;
  cta: string;
};

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-01",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20rainy%20old%20city%20alley%20at%20night%20with%20a%20lone%20figure%20holding%20an%20umbrella%2C%20deep%20blue%20atmosphere%20punctuated%20by%20warm%20orange%20streetlamps%2C%20reflective%20wet%20pavement%2C%20dramatic%20artistic%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=fm3-hero-01&orientation=landscape",
    tag: "第一季 · 开篇",
    title: "雨夜归人",
    subtitle: "有些真相，迟到十年",
    desc: "阔别故乡十年的程野在暴雨中回到旧城，与母亲旧友苏晚晴的意外重逢，揭开了一段被时间掩埋的往事。",
    link: "/detail/ep-01",
    cta: "查看剧情",
  },
  {
    id: "hero-02",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20dimly%20lit%20family%20dining%20room%20with%20a%20warm%20hanging%20lamp%20and%20deep%20blue%20shadows%2C%20empty%20chairs%20around%20a%20wooden%20table%2C%20melancholic%20emotional%20mood%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=fm3-hero-02&orientation=landscape",
    tag: "本周更新",
    title: "沉默的饭桌",
    subtitle: "十年后的第一顿晚餐",
    desc: "程野与母亲共进十年来第一顿晚餐。桌上摆满了他儿时爱吃的菜，两人却始终找不到可以说的话题。",
    link: "/detail/ep-02",
    cta: "查看剧情",
  },
  {
    id: "hero-03",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20heavy%20rain%20outside%20a%20single%20lit%20window%20of%20a%20dark%20old%20building%2C%20deep%20blue%20storm%20tones%20with%20warm%20orange%20interior%20glow%2C%20tense%20dramatic%20mood%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=fm3-hero-03&orientation=landscape",
    tag: "高潮章节",
    title: "暴雨再临",
    subtitle: "医院走廊里的答案",
    desc: "母亲的病情在雨夜突然恶化，程野在医院长椅上守了整夜，终于等来一个答案，却发现自己可能并不想听。",
    link: "/detail/ep-05",
    cta: "查看剧情",
  },
  {
    id: "hero-04",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20two%20silhouettes%20on%20a%20rooftop%20overlooking%20an%20old%20city%20at%20sunset%2C%20deep%20blue%20dusk%20sky%20with%20warm%20orange%20horizon%20horizon%20glow%2C%20hopeful%20dramatic%20mood%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=fm3-hero-04&orientation=landscape",
    tag: "收官在即",
    title: "天台上的选择",
    subtitle: "往前走，别回头",
    desc: "真相揭开之后，程野与苏晚晴站在天台上面对各自的选择。旧城还在，人事已非，往后的路只能自己走。",
    link: "/detail/ep-10",
    cta: "查看剧情",
  },
];

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "剧情介绍", path: "/category" },
  { label: "资讯专题", path: "/special" },
  { label: "搜索", path: "/search" },
  { label: "关于", path: "/about" },
];

export const quickCategories = [
  {
    id: "qc-1",
    icon: "ri-book-open-line",
    label: "剧情介绍",
    desc: "按章节浏览完整剧情脉络",
    path: "/category?type=剧情介绍",
  },
  {
    id: "qc-2",
    icon: "ri-film-line",
    label: "幕后花絮",
    desc: "摄制组的现场与制作故事",
    path: "/category?type=幕后花絮",
  },
  {
    id: "qc-3",
    icon: "ri-user-star-line",
    label: "角色解读",
    desc: "深入核心人物的内心世界",
    path: "/category?type=角色解读",
  },
  {
    id: "qc-4",
    icon: "ri-newspaper-line",
    label: "影视资讯",
    desc: "官方发布与行业观察",
    path: "/special",
  },
];